import React, { useEffect, useState } from "react";
import cls from 'classnames';
import { ArchiveView } from "./ArchiveView";
import styles from './archive.module.scss';
import { Button } from "../core/button";
import FontAwesomeIcon from "../core/fa_icon";

type Props = {
  open: boolean;
  onClose: () => void;
}

/**
 * A modal with the archive view.
 */
export const ArchiveModal: React.FC<Props> = ({ open, onClose }) => {
  const [hidden, setHidden] = useState(!open);

  useEffect(() => {
    if (open) {
      setHidden(false);
    }
  }, [open]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className={cls([styles.modal, open ? styles.open : null])}
      onTransitionEnd={() => {
        if (!open) {
          setHidden(true);
        }
      }}>
      {
        !hidden ? (
          <ArchiveView
            onRevise={() => onClose()} />
        ) : null
      }
      <Button className={styles.close} weight="simple" onClick={() => onClose()}>
        <FontAwesomeIcon name="times" />
      </Button>
    </div>
  );
}